import { X } from 'lucide-react';

// Requirement indicator: a muted ✗ until the minimum is met, then the golden
// Onda "O" (same gradient-text mark as OndaSpinner). Used on the onboarding
// Documents / Photos / Socials steps and the verify checklist.
export default function OndaProgressO({ met, label, count, required, className = '' }) {
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <span className="w-6 h-6 flex items-center justify-center shrink-0">
        {met ? (
          <span className="font-cormorant text-xl font-bold bg-gradient-to-r from-primary to-secondary bg-clip-text text-transparent leading-none">
            O
          </span>
        ) : (
          <X className="h-4 w-4 text-muted-foreground/60" />
        )}
      </span>
      <span className={`text-sm ${met ? 'text-primary' : 'text-muted-foreground'}`}>
        {label}
        {required != null && (
          <span className="ml-1 font-medium">
            {met ? '✓' : `— ${count ?? 0} of ${required}`}
          </span>
        )}
      </span>
    </div>
  );
}
